<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-4">
    <v-expansion-panel-header
      id="rec_fbi_cde"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6"
      >FEDERAL BUREAU OF INVESTIGATION (FBI) CRIME DATA EXPLORER
      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template></v-expansion-panel-header
    >
    <v-expansion-panel-content color="grey lighten-5">
      <div class="mt-6" style="color: black">
        <a href="https://cde.ucr.cjis.gov/" target="_blank"
          >FBI'S CRIME DATA EXPLORER (CDE)</a
        >
        aims to provide transparency, create easier access, and expand awareness
        of criminal, and noncriminal, law enforcement data sharing; improve
        accountability for law enforcement; and provide a foundation to help
        shape public policy with the result of a safer nation. Use the CDE to
        discover available data through visualizations, download data in .csv
        format, and other large data files.
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
@import "../scss/site.scss";
.bcs-expansion-content {
  color: black;
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "rec_fbi_cde",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
